export default {
  FIRSTNAME_DOSE_NOT_EXIST: "نام وارد نشده است.",
  LASTNAME_DOSE_NOT_EXIST: "نام خانوداگی وارد نشده است.",
  CATEGORY_USER_ID_DOSE_NOT_EXIST: "شماره دسته وارد نشده.",
  PHONE_DOSE_NOT_EXIST: "شماره تلفن وارد نشده است.",
  IDENTITY_CODE_DOSE_NOT_EXIST: "شماره ملی وارد نشده است.",
  NATIONAL_CODE_DOSE_NOT_EXIST: "کد ملی وارد نشده است.",
  STATE_DOSE_NOT_EXIST: "استان وارد نشده است.",
  CITY_DOSE_NOT_EXIST: "شهر وارد نشده است.",
  TOWN_DOSE_NOT_EXIST: "شهرستان وارد نشده است.",
  POSTAL_CODE_DOSE_NOT_EXIST: "کد پستی وارد نشده است.",

  FIRSTNAME_IS_WRONG: "نام شتباه است.",
  LASTNAME_IS_WRONG: "نام خانوداگی اشتباه است.",
  CATEGORY_USER_ID_IS_WRONG: "شماره دسته اشتباه است.",
  PHONE_IS_WRONG: "تلفن اشتباه است.",
  IDENTITY_CODE_IS_WRONG: "شماره شناسنامه اشتباه است.",
  NATIONAL_CODE_IS_WRONG: "کد ملی اشتباه است.",
  POSTAL_CODE_IS_WRONG: "کد پستی اشتباه است.",
  STATE_IS_WRONG: "استان اشتباه است.",
  CITY_IS_WRONG: "شهر اشتباه است.",
  TOWN_IS_WRONG: "شهرستان اشتباه است.",

  USER_MOBILE_DOSE_NOT_EXIST: "شماره موبایل وارد نشده.",
  USER_MOBILE_WRONG: "شماره موبایل شما نامعتبر است.",

  OPERATION_SUCCESS:
    "اطلاعات شما ثبت شد و به زودی توسط تیم پشتیبانی ما بررسی میشود و نتیجه به شما اعلام خواهد شد.",
  OPERATION_FAILED: "عملیات با موفقیت انجام شد.",
};
